<ng-template #profilePopupContent let-modal>
  <sb-modal-header [modalTitle]="modalTitle" (onClose)="closePopup()"></sb-modal-header>
  <sb-sub-menu [pageMenuItems]="menuItems$ | async" outlet="profile"></sb-sub-menu>
  <div class="modal-body p-0">
    <router-outlet name="profile"></router-outlet>
  </div>
</ng-template>
